/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-static-element-interactions */
import { useEffect, useState } from 'react';

const Toggle = ({
	onComponent,
	offComponent,
	onToggle,
	value,
}: ToggleProps) => {
	const [enabled, setEnabled] = useState(value || false);

	useEffect(() => {
		if (enabled !== value) {
			setEnabled(value);
		}
	}, [value]);

	return (
		<div className="relative flex flex-col justify-center overflow-hidden">
			<div className="flex">
				<label className="inline-flex relative items-center mr-5 cursor-pointer">
					<input
						type="checkbox"
						className="sr-only peer"
						checked={enabled}
						readOnly
					/>

					<div
						onClick={() => {
							const newValue = !enabled;
							setEnabled(newValue);
							if (onToggle) {
								onToggle(newValue);
							}
						}}
						className="w-11 h-6 bg-grey-subtle rounded-full peer  peer-focus:ring-green-300  peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-0.5 after:left-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all peer-checked:bg-red-primary"
					/>
					{enabled ? onComponent : offComponent}
				</label>
			</div>
		</div>
	);
};

export default Toggle;
